export const STEP_TYPE_NAMES = {
  PROMPT: 'prompt',
  PLUGIN: 'plugin',
  MEMORY: 'knowledge',
  INPUT: 'input',
  OUTPUT: 'output',
};
